import React from "react";

export const ContentCredits = ({ credits }: { credits: string }) =>
	credits && <div className="content-credits">{credits}</div>;
